export function text2Kebab(s: string): string {
  return s
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function convertHtml2Text(html: string): string {
  if (!html) {
    return html;
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = html;
  return textarea.value;
}

/**
 * Replaces <pre> tags with <span> tags to avoid sanitization issues
 * and allow proper styling without monospace font
 * Preserves all attributes from the original <pre> tag
 */
export function replacePreTags(html: string): string {
  if (!html) {
    return html;
  }

  // Replace opening <pre> tags (with or without attributes) with <span>
  // This regex matches <pre> with any attributes and preserves them while adding the pre-replaced class
  html = html.replace(/<pre(\s[^>]*)?>/gi, (match, attrs = '') => {
    // If attributes exist, add the class; otherwise add class attribute
    if (attrs) {
      // Check if class attribute already exists
      const classMatch = attrs.match(/class\s*=\s*["']([^"']+)["']/i);
      if (classMatch) {
        // Add pre-replaced to existing class
        return `<span${attrs.replace(/class\s*=\s*["']([^"']+)["']/i, `class="${classMatch[1]} pre-replaced"`)}>`;
      } else {
        // Add class attribute while preserving other attributes
        return `<span class="pre-replaced"${attrs}>`;
      }
    } else {
      return '<span class="pre-replaced">';
    }
  });

  // Replace closing </pre> tags with </span>
  html = html.replace(/<\/pre>/gi, '</span>');

  return html;
}